var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import { Button } from "@mui/material";
import { useTranslation } from "react-i18next";
var LIST_LINKS = [
    { label: 'Marketing', path: '/system/marketingStatistics' },
    { label: 'Bookings', path: '/system/reservations' },
    { label: 'Folios', path: '/system/folios' },
];
var ProfileListActions = function (_a) {
    var profileId = _a.profileId, children = _a.children;
    var t = useTranslation().t;
    return (_jsxs(_Fragment, { children: [LIST_LINKS.map(function (link) { return (_jsx(Button, __assign({ variant: 'outlined', href: "".concat(link.path, "?").concat(new URLSearchParams({ profileId: profileId !== null && profileId !== void 0 ? profileId : '' }).toString()), target: '_blank', rel: 'noopener noreferrer', disabled: !profileId, endIcon: _jsx(OpenInNewIcon, { sx: { fontSize: '16px !important' } }) }, { children: t(link.label) }), link.label)); }), children] }));
};
export default ProfileListActions;
